import request from '../../request'

export default {
  actions: {
    // list all products
    getSuperProducts(_, parameters) {
      return request.get('super-products', {
        params: parameters
      })
    },

    // create new product
    createSuperProduct(_, payload) {
      return request.post('super-products', payload)
    },

    // update product
    updateSuperProduct(_, payload) {
      return request.put('super-products/' + payload.id, payload.product)
    },

    // delete product
    deleteSuperProduct(_, id) {
      return request.delete('super-products/' + id)
    },

    createSuperProductOrder(_, payload) {
      return request.post('super-product-order', payload);
    },

    getSuperProductOrders(_, payload) {
      return request.get('super-product-orders', {
        params: payload
      })
    },

    changeSuperProductOrderStatus(_, payload) {
      return request.post('change-super-product-order-status', payload);
    }

  }
}
